import { Helmet } from 'react-helmet-async';
import { Button, Container, Stack, Typography } from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';
import { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import { getRewardRequests, updateRewardRequest } from '../services/Common/rewardRequest.service';

export default function RewardRequestsPage() {
    const [requests, setRequests] = useState([]);
    const load = () => getRewardRequests().then(setRequests).catch(() => toast('Failed to load reward requests', { type: 'error' }));
    useEffect(load, []);

    const update = async (id, status) => {
        try {
            const updated = await updateRewardRequest(id, status);
            setRequests((current) => current.map((item) => item._id === id ? updated : item));
            toast(`Request marked ${status}`, { type: 'success' });
        } catch (_) {
            toast('Failed to update reward request', { type: 'error' });
        }
    };

    const columns = [
        { field: 'userName', headerName: 'Username', flex: 1, valueGetter: ({ row }) => row.user?.name || '' },
        { field: 'userId', headerName: 'User ID', flex: 1, valueGetter: ({ row }) => row.user?._id || '' },
        { field: 'tournamentName', headerName: 'Tournament', flex: 1, valueGetter: ({ row }) => row.tournament?.title || '' },
        { field: 'game', headerName: 'Game', flex: 1 },
        { field: 'rank', headerName: 'Rank', width: 80 },
        { field: 'winningAmount', headerName: 'Winning EV', width: 110 },
        { field: 'rewardDetails', headerName: 'Reward Details', flex: 1 },
        { field: 'createdAt', headerName: 'Request Date', flex: 1 },
        { field: 'status', headerName: 'Status', width: 110 },
        {
            field: 'actions', headerName: 'Actions', width: 210,
            renderCell: ({ row }) => row.status === 'pending' ? <Stack direction="row" spacing={1}>
                <Button size="small" variant="outlined" onClick={() => update(row._id, 'approved')}>Approve</Button>
                <Button size="small" color="error" onClick={() => update(row._id, 'rejected')}>Reject</Button>
            </Stack> : row.status === 'approved' ? <Button size="small" variant="contained" onClick={() => update(row._id, 'paid')}>Release EV</Button> : null,
        },
    ];

    return <>
        <Helmet><title>Reward Requests | Trooper</title></Helmet>
        <Container>
            <Typography variant="h4" sx={{ mb: 3 }}>Tournament Reward Requests</Typography>
            <div style={{ height: '75vh', width: '100%' }}>
                <DataGrid rows={requests} columns={columns} getRowId={(row) => row._id} pageSizeOptions={[10, 25, 50]} />
            </div>
        </Container>
    </>;
}
